import gql from "graphql-tag";

let cities = JSON.parse(localStorage.getItem('cities'))
let finalCondition = '';
let intermediateCondition = '';
if(cities && cities.length){
  let contractorCities = cities.map(curnt => curnt.city);
  finalCondition = 'contractorAddress: {city: {_in: '+ JSON.stringify(contractorCities) +'}}'
}

export const GET_TEMPOS = gql`
 query {
  tempo {
    id
    city
    name
    platNo
    kmLimit
    capacity
    hiringPrice
    extraKmPrice
    type
    status
    Contractor{name id}
    }
 }
`
export const GET_UNOCCUPIED_TEMPOS = gql`
 query tempo($tempoIds: [uuid!], $contractorId: uuid!){
  unOccupiedTempos: tempo(where: {_and: [{ id: {_nin: $tempoIds}},{ contractorId: {_eq: $contractorId}}]}) {
    id
    platNo
    name
    }
 }
`
export const GET_TRUCKS = gql`
 query {
  truck {
    id
    routes
    name
    platNo
    kmLimit
    capacity
    company{
     name
     id
     }
    }
 }
`
export const GET_UNOCCUPIED_TRUCKS = gql`
 query truck($truckIds: [uuid!], $transporterId: uuid!){
  unOccupiedTrucks: truck(where: {_and: [{ id: {_nin: $truckIds}},{ transporterId: {_eq: $transporterId}}]}) {
    id
    platNo
    name
    }
 }
`
export const GET_TRUCKS_BY_TRANSPORTER_ID = gql`
 query truck($transporterId: uuid!){
  truckArr:truck(where: {_and: [{ transporterId: {_eq: $transporterId}}]}) {
    id
    platNo
    name
    }
 }
`
export const GET_DRIVERS_BY_TRANSPORTER_ID = gql`
 query driverDetails($transporterId: uuid!){
  driverArr:driverDetails(where: {_and: [{ transporterId: {_eq: $transporterId}},{ driverType: {_eq: 2}}]}) {
    id
    name
    }
 }
`
export const GET_DRIVERS = gql`
 query driverDetails($driverTypeArr: [Int!]){
  driverDetails (where:{driverType:{_in:$driverTypeArr}}){
    id
    driverType
    Contractor{name id}
    Transporter{name id}
    mobile
    name
    proof
   }
 }
`
export const GET_UNOCCUPIED_TRUCK_DRIVERS = gql`
 query driverDetails($driverIds: [uuid!]){
  unOccupiedDrivers: driverDetails(where: {_and: [{ id: {_nin: $driverIds}},{ driverType: {_eq: 2}}]}) {
    id
    name
    }
 }
`
export const GET_UNOCCUPIED_TEMPO_DRIVERS = gql`
 query driverDetails($driverIds: [uuid!], $contractorId: uuid!){
  unOccupiedDrivers: driverDetails(where: {_and: [{ id: {_nin: $driverIds}},{ driverType: {_eq: 1}},
  { contractorId: {_eq: $contractorId}}]}) {
    id
    name
    }
 }
`
export const GET_CONTRACTORS = gql`
 query {
  contractor (where: {${finalCondition}, status:{_eq: true} }){
    id
    contractorCode
    name
    type
    mobile
    email
    gstin
    pan
    city
    monthlyKms
    status
    contractorAddress{id add1 add2 area city state pincode}
    }
 }
`
export const GET_CONTRACTORS_BY_CITY = gql`
 query ($selectedCity: String!){
  contractor (where: {contractorAddress: {city: {_eq: $selectedCity}}, status:{_eq: true}}){
    id
    contractorCode
    name
    type
    mobile
    email
    gstin
    pan
    city
    monthlyKms
    contractorAddress{id add1 add2 area city state pincode}
    }
 }
`
export const GET_LAST_CONTRACTOR = gql`
query {
  lastContractor: contractor(order_by: {createdAt: desc}, limit: 1) {
      id
      contractorCode
  }
}
`
export const GET_FILTERED_VEHICLES = gql`
 query {
  vehicle {
    id
    city
    name
    platNo
    type
    kmLimit
    capacity
    }
 }
`
export const SEARCH_DRIVERS = gql`
 query driverDetails($driverFilter: String!){
  driverDetails(where:{name:{_ilike:$driverFilter}},distinct_on: name, order_by: {name: asc}){
    id
    name
   }
 }
`
